import { useState } from 'react';
import clsx from 'clsx';

const PRESETS = [
  { key: 'today', label: 'اليوم' },
  { key: 'yesterday', label: 'أمس' },
  { key: 'week', label: 'الأسبوع' },
  { key: 'month', label: 'الشهر' },
  { key: 'custom', label: 'مخصّص' }
];

const isoOf = (d) => d.toISOString().slice(0, 10);

export function rangeFor(key, custom) {
  const today = new Date();
  if (key === 'today') return { from: isoOf(today), to: isoOf(today) };
  if (key === 'yesterday') {
    const y = new Date(today);
    y.setDate(y.getDate() - 1);
    return { from: isoOf(y), to: isoOf(y) };
  }
  if (key === 'week') {
    const w = new Date(today);
    w.setDate(w.getDate() - 6);
    return { from: isoOf(w), to: isoOf(today) };
  }
  if (key === 'month') {
    const m = new Date(today);
    m.setDate(m.getDate() - 29);
    return { from: isoOf(m), to: isoOf(today) };
  }
  if (key === 'custom' && custom) {
    return { from: custom.from || isoOf(today), to: custom.to || isoOf(today) };
  }
  return { from: isoOf(today), to: isoOf(today) };
}

export function DateRangePicker({ value, onChange }) {
  const [preset, setPreset] = useState(value?.preset || 'today');
  const [from, setFrom] = useState(value?.from || isoOf(new Date()));
  const [to, setTo] = useState(value?.to || isoOf(new Date()));

  function applyPreset(key) {
    setPreset(key);
    if (key !== 'custom') {
      const r = rangeFor(key);
      setFrom(r.from);
      setTo(r.to);
      onChange?.({ preset: key, from: r.from, to: r.to });
    } else {
      onChange?.({ preset: 'custom', from, to });
    }
  }

  function applyCustom(nextFrom, nextTo) {
    setPreset('custom');
    setFrom(nextFrom);
    setTo(nextTo);
    onChange?.({ preset: 'custom', from: nextFrom, to: nextTo });
  }

  return (
    <div className="flex items-center gap-2 flex-wrap">
      <div className="inline-flex items-center gap-1 p-1 bg-white border border-line rounded-[10px] shadow-card">
        {PRESETS.map((p) => (
          <button
            key={p.key}
            type="button"
            onClick={() => applyPreset(p.key)}
            className={clsx(
              'px-3 py-1.5 rounded-[8px] text-[12px] font-semibold transition-colors',
              preset === p.key
                ? 'bg-orange text-white shadow-orange-glow'
                : 'text-ink-2 hover:bg-paper-2'
            )}
          >
            {p.label}
          </button>
        ))}
      </div>
      {preset === 'custom' ? (
        <div className="flex items-center gap-2 bg-white border border-line rounded-[10px] shadow-card px-3 py-1.5">
          <input
            type="date"
            className="text-[12px] outline-none border-0 bg-transparent"
            value={from}
            onChange={(e) => applyCustom(e.target.value, to)}
          />
          <span className="text-ink-3 text-xs">إلى</span>
          <input
            type="date"
            className="text-[12px] outline-none border-0 bg-transparent"
            value={to}
            onChange={(e) => applyCustom(from, e.target.value)}
          />
        </div>
      ) : null}
    </div>
  );
}
